export function endOfMonth(date) {
  let endOfMonth = new Date(+date);
  endOfMonth.setMonth(endOfMonth.getMonth() + 1);
  endOfMonth.setDate(0);
  return endOfMonth;
}
